// @flow
import React from 'react'
import { ConditionName } from '../../actions'
import { CONDITION_ITEMS_FOR_CONDITION_SELECTOR } from '../../constants/conditions'
import listenToClickOutside from 'react-onclickoutside'
import { ConditionCircleWrapper, ConditionIcon } from './ConditionCircle'
import { Tooltip, colors } from 'plume-ui'
import { css } from '@emotion/react'

type Props = {
  selected: ConditionName[]
  open: boolean
  onToggle: () => any
  onSelect: (cond: ConditionName) => any
  onRemove: (cond: ConditionName) => any
}

class ConditionSelector extends React.Component<Props> {
  handleClickOutside() {
    if (this.props.open) {
      this.props.onToggle()
    }
  }

  handleOnRemove(e: any, name: any) {
    e.stopPropagation()
    this.props.onRemove(name)
  }

  render() {
    return (
      <ConditionCircleWrapper>
        <Tooltip label="フィルタを追加">
          <div
            onClick={this.props.onToggle}
            className={'add-filter-btn'}
            css={css`
              display: flex;
              align-items: center;
              justify-content: center;
              box-sizing: border-box;
              background-color: #ffffff;
              border: 2px solid ${colors.cyan50};
              border-radius: 50%;
              margin-block: -12px;
              width: 42px;
              height: 42px;
              line-height: 1;
              transition: 0.15s;
              :hover {
                background-color: ${colors.cyan50};
                border: 2px solid ${colors.cyan50};
                /* あまり良くないselectorだが、この要素自体の利用scopeを狭めたい */
                * {
                  transition: 0.15s;
                  color: #fff;
                }
              }
            `}
          >
            <ConditionIcon />
          </div>
        </Tooltip>
        <ul
          className={
            this.props.open
              ? 'condition-dropdown is-opening'
              : 'condition-dropdown'
          }
          css={css`
            background: #fff;
            border: 1px solid #d9d9d9;
            box-shadow: 1px 1px 1px #d9d9d9;
            opacity: ${this.props.open ? 1 : 0};
            visibility: ${this.props.open ? `visible` : `hidden`};
            padding: 5px 0;
            position: absolute;
            list-style: none;
            min-width: 272px;
            white-space: nowrap;
            transition: 0.2s;
            z-index: 1;
            left: -66px;
            margin-top: 5px;
            &.condition-dropdown:before {
              border-left: 10px solid transparent;
              border-right: 10px solid transparent;
              border-bottom: 10px solid #fff;
              border-bottom-color: #d9d9d9;
              content: ' ';
              height: 0;
              position: absolute;
              width: 0;
              top: -10px;
              left: 28.5%;
            }
            &.condition-dropdown:after {
              border-left: 10px solid transparent;
              border-right: 10px solid transparent;
              border-bottom: 10px solid #fff;
              top: -9px;
              content: ' ';
              height: 0;
              position: absolute;
              width: 0;
              left: 28.5%;
            }
          `}
        >
          {Object.keys(CONDITION_ITEMS_FOR_CONDITION_SELECTOR).map(
            (name, i) => (
              <li
                key={`${i}-${name}`}
                className={
                  this.props.selected.includes(name as ConditionName)
                    ? 'is-selected'
                    : ''
                }
                onClick={() => this.props.onSelect(name as ConditionName)}
                css={css`
                  position: relative;
                  color: #666;
                  font-size: 14px;
                  padding: 3px 10px 4px 25px;
                  rgin: 0;
                  line-height: 20px;
                  &.is-selected:before {
                    content: '\\A';
                    background: ${colors.cyan50};
                    display: inline-block;
                    left: 10px;
                    width: 6px;
                    border-radius: 50%;
                    height: 6px;
                    position: absolute;
                    top: 8px;
                  }
                  :hover {
                    background-color: #f1f1f1;
                  }
                `}
              >
                {CONDITION_ITEMS_FOR_CONDITION_SELECTOR[name].label}
                {this.props.selected.includes(name as ConditionName) ? (
                  <i
                    className="icomoon icon-close2 close"
                    onClick={(e) => this.handleOnRemove(e, name)}
                    css={css`
                      color: #333;
                      position: absolute;
                      right: 5px;
                      font-size: 17px;
                      transition: 0.2s;
                      opacity: 0.2;
                      :hover {
                        text-decoration: none;
                        cursor: pointer;
                        opacity: 0.4;
                      }
                    `}
                  />
                ) : null}
              </li>
            )
          )}
        </ul>
      </ConditionCircleWrapper>
    )
  }
}

export default listenToClickOutside(ConditionSelector)
